import withSelectHookForm from '../hoc/withSelectHookForm';
import SelectBox from './SelectBox';

const SelectBoxWithHookForm = withSelectHookForm(SelectBox);

export default SelectBoxWithHookForm;
